import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Sales API client - routes prefixed with /api/sales
const salesApiClient = axios.create({
  baseURL: `${BACKEND_URL}/api/sales`,
});

salesApiClient.interceptors.request.use((config) => {
  // First try sales-specific token, then fallback to main auth token
  const token = localStorage.getItem('salesToken') || localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

salesApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't auto-redirect, let the app handle it
      console.error('Sales API: Unauthorized');
    }
    return Promise.reject(error);
  }
);

export default salesApiClient;
